import MaterialTable from "@material-table/core";
import MatTableHeader from "../../MaterialTableHeader/MatTableHeader";
import { log } from "../../../Helper";
import React, { useEffect, useState } from "react";
import { quoteResultsDataForwarder } from "../../api";
import LoaderComponent from "../../../LoaderComponent/LoaderComponent";
import { useUserInfo } from "../../../common/user-context";
import { sortByPriceWithCurrency } from "../../../utils/utils";
import useFilterState from "../../../hooks/useFilterState";
import _ from "lodash";

const QuoteResultsMaterialTable = ({ tableName }) => {
  const { userData } = useUserInfo();
  const [quoteResultsForwarder, setQuoteResultsForwarder] = useState(Array(0));
  const [pageSize, setPageSize] = useState(5000);
  const [pageNumber, setPageNumber] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const getQuoteResultsDataForwarder = async () => {
    setIsLoading(true);
    try {
      const response = await quoteResultsDataForwarder(
        pageNumber,
        pageSize,
        userData
      );
      if (!response || !Array.isArray(response)) {
        setQuoteResultsForwarder([]);
      } else {
        setQuoteResultsForwarder(response);
      }
    } catch (error) {
      log("Error occured while fetching quote results: ", error);
      setQuoteResultsForwarder(Array(0));
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (userData.length > 0 || userData.userId) {
      getQuoteResultsDataForwarder();
    }
  }, [userData]);

  const columns = [
    {
      title: "Comar",
      field: "comar",
      sorting: false,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Pick-Up",
      field: "pickupLocation",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Destination",
      field: "destination",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Product",
      field: "product",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Dimensions",
      field: "dimension",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Weight",
      field: "weight",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Expected Pickup",
      field: "expectedTimeframe",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Announcement Date",
      field: "modifiedDate",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Amount",
      field: "amount",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
      customSort: (a, b) => {
        return sortByPriceWithCurrency(a.amount, b.amount);
      },
    },
    {
      title: "Result",
      field: "result",
      cellStyle: (result) => {
        return {
          fontWeight: "bold",
          color: "#FFFFFF",
          backgroundColor: result === "WON" ? "#367C2B" : "#BD2E28",
        };
      },
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
  ];

  const [columnsWithFilter, handleFilterChange] = useFilterState(
    tableName,
    columns
  );

  return (
    <>
      {isLoading && <LoaderComponent />}

      {!isLoading && (
        <div className="flex flex-col justify-center items-center mt-[-1.5rem]">
          <MatTableHeader getTableData={getQuoteResultsDataForwarder} />
          <MaterialTable
            columns={columnsWithFilter.map((col, index) => {
              if (
                col.tableData?.filterValue == "" ||
                col.tableData?.filterValue == null ||
                col.tableData?.filterValue == undefined
              ) {
                let colWithoutDefaultFilter = _.omit(
                  col,
                  "defaultFilter",
                  "tableData.filterValue"
                );
                return colWithoutDefaultFilter;
              } else {
                return {
                  ...col,
                  defaultFilter: col.tableData?.filterValue,
                };
              }
            })}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h6 className="left-[45%] absolute top-[40%] text-center">
                    No records to display
                  </h6>
                ),
              },
              pagination: {
                labelRowsPerPage: "Orders Per Page",
                labelRowsSelect: "Orders",
              },
            }}
            options={{
              rowStyle: {
                fontSize: 10,
              },
              selection: false,
              search: false,
              showTitle: false,
              pageSize: 100,
              filtering: true,
              maxBodyHeight: 600,
              draggable: false,
              headerStyle: {
                backgroundColor: "#367c2b",
                fontWeight: "400",
                color: "white",
                position: "sticky",
                top: 0,
                zIndex: 10,
              },
              tableContainerStyle: {
                maxHeight: 600,
                overflow: "auto",
              },
              pageSizeOptions: [100, 500, 1000],
              filterCellStyle: {
                flex: 1
              },
            }}
            title={"Quote Results"}
            data={quoteResultsForwarder}
            onFilterChange={(filters) => {
              // Create a map of current filters for quick lookup
              const filterMap = new Map();
              filters.forEach((filter) => {
                filterMap.set(filter.column.tableData.id, filter.value);
              });

              // Iterate over all columns to ensure each one is checked if the value is present in the filter map
              columnsWithFilter.forEach((col, columnId) => {
                const newValue = filterMap.get(columnId) || ""; // Default to empty string if not found

                // Update the filter state for each column
                handleFilterChange(columnId, newValue);
              });
            }}
          />
        </div>
      )}
    </>
  );
};

export default QuoteResultsMaterialTable;
